export default "/images/997c874836a0e6145ea06075f3d25a70.avif";